var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infinite-tree-item",class:{
        'is-expanded': _vm.node.expanded,
        'is-current': _vm.node.isCurrent,
        'is-hidden': !_vm.node.visible,
    },attrs:{"aria-expanded":_vm.node.expanded},on:{"click":_vm.handleNodeClick,"contextmenu":_vm.handleNodeContextMenu}},[_c('div',{staticClass:"tree-node__content",style:({'padding-left': (_vm.node.level - 1) * _vm.tree.indent + 'px'})},[_c('span',{class:[
            { 'is-leaf': _vm.node.isLeaf, expanded: _vm.expanded },
            'tree-node__expand-icon',
            _vm.icon ],on:{"click":function($event){$event.stopPropagation();return _vm.handleExpandIconClick($event)}}}),_c('node-content',{attrs:{"node":_vm.node}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }